let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let Modal = require("ES/widgets/Modal");
let esUtils = require("ES/utils/esUtils");

let FormatTime = function(t){
	let time = esUtils.format_date(t, "h:MM TT");
	return time === "12:00 AM" ? null : dd.span({className: "time"}, time);
};

// Time + description on one line, with an optional muted confirmation # below.
let TimeLine = function(date, description, conf){
	return dd.div(null,
		FormatTime(date),
		" " + description,
		conf ? dd.span({className: "text-muted"}, " (" + conf + ")") : null
	);
};

// legcarrier is picked from a dropdown formatted "Delta Air Lines - DL", so the
// code is whatever trails the hyphen. The odd row carries no code at all
// ("Allegiant Air", "Other") and the AwardWallet import stores a bare "DL";
// both fall out of the same split, since pop() hands back the whole string
// when there is no hyphen in it.
let FlightNumber = function(carrier, flightnum){
	let code = _.trim(_.trim(carrier || "").split("-").pop());
	return _.compact([code, _.trim(flightnum || "")]).join(" ") || null;
};

//These types keys correspond to the event object's
let itinerary_types = {
	Flight: {
		icon: "fa-plane",
		name: "Flight",
		form: require("./FlightForm"),
		toItinerary(flight){
			// The flight description belongs to the whole flight, not each leg, so it
			// rides along as a separate header that DayItinerary shows only once for
			// back-to-back legs of the same flight.
			let header = flight.description ? dd.div(null,
				dd.span({style: {fontWeight: "bold"}}, flight.description),
				flight.agent ? dd.span({className: "text-muted"}, " (" + flight.agent + ")") : null
			) : null;

			// One itinerary entry per leg, each filed under its own departure
			// (legleave) day, so multi-day flights don't collapse onto a single date.
			return _.map(flight.legs, function(leg){
				let flightnum = FlightNumber(leg.legcarrier, leg.legflightnum);

				return {
					date: leg.legleave,
					header: header,
					group: flight,
					custom: dd.div(null,
						FormatTime(leg.legleave),
						dd.span({}, " depart "),
						leg.legfrom,
						flightnum ? dd.span({}, " on " + flightnum) : null,
						dd.br(),
						FormatTime(leg.legarrive),
						dd.span({}, " arrive "),
						leg.legto
					)
				};
			});
		}
	},
	Hotel: {
		icon: "fa-building",
		name: "Hotel",
		form: require("./HotelForm"),
		toItinerary(hotel){
			return [
				{date: hotel.checkindate, custom: TimeLine(hotel.checkindate, "Check-in " + hotel.name, hotel.confirmation)},
				{date: hotel.checkoutdate, custom: TimeLine(hotel.checkoutdate, "Check-out " + hotel.name, hotel.confirmation)}
			];
		}
	},
	Ground: {
		icon: "fa-car",
		name: "Ground",
		form: require("./GroundForm"),
		toItinerary(ground){
			return {date: ground.starttime, custom: TimeLine(ground.starttime, ground.description, ground.confirmation)};
		}
	}
};

let eventToDayItinerary = function(event){
	return _.map(_.groupBy(_.sortBy(_.filter(_.flattenDeep(_.map(itinerary_types, function(itinerary_attributes, type){
		return _.map(event[type], function(obj){
			let conv = itinerary_attributes.toItinerary(obj);
			return _.map(_.flattenDeep([conv]), function(item){
				item.id = obj.id;
				item.type = type;
				return item;
			});
		});
	})), function(item){
		return (-631126800 == item.date || -631134000 == item.date) || _.isDate(item.date);
	}), "date"), function(item){
		return esUtils.format_date(item.date, "yyyy-mm-dd"); //group by day
	}), function(legs){
		return {
			head: (-631126800 == legs[0].date || -631134000 == legs[0].date) ? 'no date set' : esUtils.format_date(legs[0].date, "dddd, mmmm d, yyyy"),
			legs: _.sortBy(legs, "date")
		};
	});
};

let DayItinerary = dd.createClass({
	render(){
		let {itinerary, showForm, read_only} = this.props;

		return dd.div({className: "DayItinerary"},
			dd.div({className: "travel-head"},
				itinerary.head
			),
			_.map(itinerary.legs, function(leg, i){
				// Only the first of a run of same-flight legs shows the flight header.
				let prev = itinerary.legs[i - 1];
				let show_header = leg.header && !(prev && leg.group && prev.group === leg.group);

				return dd.div({
						key: i,
						className: "travel-leg" + (read_only ? "" : " clickable"),
						onClick: read_only ? null : showForm(leg.type, leg.id)
					},
					dd.i({className: "fa fa-lg " + itinerary_types[leg.type].icon}),
					dd.div({className: "description"},
						show_header ? leg.header : null,
						leg.custom ? leg.custom : dd.span(null,
							FormatTime(leg.date),
							" " + leg.description
						)
					),
					dd.div({className: "clearfix"})
				);
			})
		);
	}
});

module.exports = dd.createClass({
	getInitialState(){
		return {show_form: {type: null, id: -1}};
	},
	__showForm(type, id){
		return _.bind(esUtils.wrapPreventDefault(function(){
			this.setState({show_form: {type: type, id: id}});
		}), this);
	},
	render(){
		let {event, Displaylists, read_only} = this.props;
		let {show_form} = this.state;
		let closeModal = this.__showForm(null, -1);

		return dd.div(null,
			dd.div({className: "panel panel-default"},
				dd.div({className: "panel-body"},
					_.map(eventToDayItinerary(event), function(itinerary, i){
						return DayItinerary({key: i, itinerary, showForm: this.__showForm, read_only});
					}, this),
					read_only ? null : dd.div({style: {marginTop: 30, textAlign: "center"}},
						dd.span({className: "btn-group"},
							_.map(itinerary_types, function(data, type){
								return dd.button({key: type, className: "btn btn-default btn-sm", onClick: this.__showForm(type, 0)}, dd.i({className: "fa " + data.icon}), " Add " + data.name);
							}, this)
						)
					)
				)
			),
			_.has(itinerary_types, show_form.type) ? Modal({
					title: (show_form.id > 0 ? "Edit" : "Add") + " " + itinerary_types[show_form.type].name,
					onClose: closeModal,
					buttons: []
				},
				itinerary_types[show_form.type].form({
					event: event,
					Displaylists: Displaylists,
					onCancel: closeModal,
					data: _.find(event && event[show_form.type], function(obj){
						return obj.id == show_form.id;
					}) || null
				})
			) : null
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/travel/Itinerary.js